import React from 'react';

const CommonCheckbox = ({
    name,
    label,
    value,
    onChange,
    errors,
    disabled = false,
    required = false,
    className = 'mb-3'
}) => {
    const handleChange = (e) => {
        onChange({
            target: {
                name,
                type: 'checkbox',
                checked: e.target.checked
            }
        });
    };

    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-check-label user-select-none m-0 me-2" htmlFor={name}>
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            <div className="form-check form-switch form-switch-md m-0 py-2">
                <input
                    type="checkbox"
                    className={`form-check-input ${errors?.[name] ? 'is-invalid' : ''}`}
                    id={name}
                    name={name}
                    checked={value}
                    onChange={handleChange}
                    disabled={disabled}
                />
                <span className="ms-2">{value ? 'Yes' : 'No'}</span>
            </div>
            {errors?.[name] && (
                <div className="invalid-feedback">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}
        </div>
    );
};

export default CommonCheckbox; 